module.exports = __webpack_public_path__ + "static/media/sunCreme (8).6146c021.jpg";